export default {
  created(el) {
    el.setAttribute("v-scroll-animate", "");
  },
  mounted(el) {
    //el.setAttribute("v-scroll-animate", "");
    const options = {
      root: null,
      threshold: 0.1,
      rootMargin: "0px 0px -10% 0px",
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          el.removeAttribute("v-scroll-animate");
          el.classList.add("fade-in");
        });
        observer.unobserve(el);
      }
    }, options);

    observer.observe(el);
  },
};
